import { CurrentCardService, MyCardService } from '@addins/core/core';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { CLocation } from '@models/imported/SagaSchema/CLocation';
import { CallCard } from '@models/imported/SagaSchema/CallCard';
import { Initializer } from '@services/initializer/initializer.service';
import { ProfileReaderService } from '@services/profile-reader/profile-reader.service';
import { SagaSettingsService } from '@services/settings';
import { AddinView } from '@techwan/ionic-core';
import { CallCardListBaseComponent } from '../../components/callcard-list-base/callcard-list-base.component';
import { CallCardGroupsService } from '../../services/callcard-groups/callcard-groups.service';
import { CallCardsProviderService } from '../../services/callcards-provider/callcards-provider.service';

@Component({
  selector: 'app-callcard-list-full',
  templateUrl: './callcard-list-full.component.html',
  styleUrls: ['./callcard-list-full.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
@AddinView({
  name: 'CardListFull',
  description: "Use to display a list of CallCards read from the CallCard's service",
  icon: 'list'
})
export class CallcardListFullComponent extends CallCardListBaseComponent implements OnInit, OnDestroy {
  get myCard() {
    return this.myCardService.myCard;
  }

  showStatusColor: boolean = false;

  private removerFunctions: Function[] = [];

  constructor(
    protected _initializer: Initializer,
    protected _callCardsProvider: CallCardsProviderService,
    private myCardService: MyCardService,
    private currentCardService: CurrentCardService,
    protected cardGroups: CallCardGroupsService,
    private profileReader: ProfileReaderService,
    private sagaSettings: SagaSettingsService,
    private changeDetector: ChangeDetectorRef
  ) {
    super(_initializer, _callCardsProvider);
  }

  ngOnInit() {
    super.ngOnInit();
  }

  ngOnDestroy() {
    super.ngOnDestroy();

    while (this.removerFunctions.length > 0) {
      this.removerFunctions.pop()();
    }
  }

  protected onComplete(isComplete: boolean) {
    super.onComplete(isComplete);

    if (isComplete === true) {
      this.showStatusColor = this.profileReader.getComponentConfig('listcallcards', 'showStatusColor', false);

      this.setupCardsSorting();

      this.cards.onRefresh.subscribe(cards => this.onCallcardsChanged(cards));
      this.onCallcardsChanged(this.cards.items);
    }
  }

  private setupCardsSorting() {
    const callcardsSortByField: string = this.sagaSettings.getValue('SagaMobileWebClient.CallcardsSortByField');
    if (callcardsSortByField === 'Location') {
      this.removerFunctions.push(this.cards.addSort((a, b) => this.locationCompare(a, b)));
    } else {
      this.removerFunctions.push(this.cards.addSort((a, b) => a.compare(b)));
    }
  }

  private locationCompare(a: CallCard, b: CallCard): number {
    const locationA: CLocation = a.location;
    const locationB: CLocation = b.location;

    return (
      locationA.CityName.localeCompare(locationB.CityName) ||
      locationA.PlaceName.localeCompare(locationB.PlaceName) ||
      locationA.StreetNumber.localeCompare(locationB.StreetNumber) ||
      a.compare(b)
    );
  }

  private onCallcardsChanged(callcards: CallCard[]) {
    this.cardGroups.refresh(callcards);
    this.changeDetector.markForCheck();
  }

  open(callcard: CallCard) {
    this.currentCardService.select(callcard);
  }
}
